<template>
  <el-row
    v-loading.fullscreen.lock="loading"
    type="flex"
    :justify="isMobile ? 'start' : 'center'"
    class="flex-full-xs flex-column-items-xs"
  >
    <div class="white-box flex-full-xs flex-column-items-xs">
      <el-row
        :xs="10"
        :sm="9"
        :md="8"
        :lg="7"
        :xl="6"
      >
        <facebook-login
          class="button"
          :app-id="facebookAppId"
          :login-label="$t('welcome.facebook.login')"
          :logout-label="$t('welcome.facebook.logout')"
          @login="getUserDataFacebook"
          @logout="onLogoutFacebook"
        />
      </el-row>
      <el-row
        :xs="10"
        :sm="9"
        :md="8"
        :lg="7"
        :xl="6"
      >
        <google-login
          class="button"
          :login-label="$t('welcome.google.login')"
          :logout-label="$t('welcome.google.logout')"
          @login="getUserDataGoogle"
          @logout="onLogoutGoogle"
        />
        <!--<el-button class="google-button" round>-->
        <!--<i class="icon-google"><i class="path1"></i><i class="path2"></i><i class="path3"></i><i-->
        <!--class="path4"></i></i>-->
        <!--Continue with <b>Google</b>-->
        <!--</el-button>-->
      </el-row>
      <el-row
        :xs="10"
        :sm="9"
        :md="8"
        :lg="7"
        :xl="6"
        class="with-email"
      >
        <p>{{ $t('welcome.continue-email') }}</p>
        <el-row
          type="flex"
          justify="center"
          class="login-signup"
        >
          <router-link
            :to="{ name: 'Login' }"
            class="login-button"
          >
            {{ $t('welcome.login.title') }}
          </router-link>
          <span>|</span>
          <router-link
            :to="{ name: 'SignUp' }"
            class="signup-button"
          >
            {{ $t('welcome.signup.title') }}
          </router-link>
        </el-row>
      </el-row>
    </div>
  </el-row>
</template>

<script>
import { mapState } from 'vuex';
import FacebookLogin from '@/components/conectivity/FacebookLogin';
import GoogleLogin from '@/components/conectivity/GoogleLogin';

export default {
  components: {
    FacebookLogin,
    GoogleLogin,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      facebookAppId: state => state.config.facebookAppId,
    }),
  },
  methods: {
    getUserDataFacebook({ response }) {
      if (response.status === 'connected' && response.authResponse && response.authResponse.accessToken) {
        this.loading = true;
        this.$store.dispatch('login', {
          url: 'auth/login-facebook',
          credentials: { token: response.authResponse.accessToken },
        })
          .then(() => {
            this.loading = false;
            this.$router.push({ name: 'Home' });
          })
          .catch(({ error }) => {
            this.loading = false;
            if (error.status === 422) {
              this.errors = error.data.errors;
            }
          });
      }
    },
    onLogoutFacebook(/* ...vars */) {
      //   console.log('onLogout', vars);
    },
    getUserDataGoogle(content) {
      if (content && content.authorizationCode) {
        this.loading = true;
        this.$store.dispatch('login', {
          url: 'auth/login-google',
          credentials: { token: content.authorizationCode },
        })
          .then(() => {
            this.loading = false;
            this.$router.push({ name: 'Home' });
          })
          .catch(({ response }) => {
            this.loading = false;
            if (response.status === 422) {
              this.errors = response.data.errors;
            }
          });
      }
    },
    onLogoutGoogle(/* ...vars */) {
      // console.log('onLogout', vars);
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/WelcomeBox.vue